import React from 'react';
import styled, { css } from 'styled-components';

interface CaptionProps extends React.AllHTMLAttributes<HTMLElement> {
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
  level?: '1' | '2' | '3' | '4';
  caps?: boolean;
}

const level4 = css`
  font-size: 9px;
  line-height: 12px;
`;
const level3 = css`
  font-size: 11px;
  line-height: 14px;
`;
const level2 = css`
  font-size: 12px;
  line-height: 14px;
`;
const level1 = css`
  font-size: 13px;
  line-height: 16px;
`;
const bold = css`
  font-weight: 700;
`;
const semibold = css`
  font-weight: 600;
`;
const medium = css`
  font-weight: 500;
`;
const regular = css`
  font-weight: 400;
`;
const CaptionCaps = css`
  text-transform: uppercase;
`;
export const StyledCaption = styled.span<{
  weight: string;
  level: string;
  caps: boolean;
  color?: string;
}>`
  display: block;
  margin: 0;

  ${props => props.caps && CaptionCaps};

  ${props => props.level === '1' && level1};
  ${props => props.level === '2' && level2};
  ${props => props.level === '3' && level3};
  ${props => props.level === '4' && level4};

  ${props => props.weight === 'regular' && regular};
  ${props => props.weight === 'medium' && medium};
  ${props => props.weight === 'semibold' && semibold};
  ${props => props.weight === 'bold' && bold};

  ${props => props.color && `color: ${props.color}`};
`;

const CaptionComponent = ({
    children,
    color,
    weight = 'regular',
    level = '1',
    caps = false,
  }: CaptionProps) => {
  return (
    <StyledCaption
      weight={weight}
      level={level}
      caps={caps ?? false}
      color={color}
    >
      {children}
    </StyledCaption>
  );
};

export default CaptionComponent;
